import { getDataWithPromise, handleAjaxError} from "./BaseDataFns";

export const getNews = (school_id, onCompleteFunc) => {

  const url =  Globals.APIFolder + '/school/' + school_id + '/news' ;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
  .catch((jqXHR, textStatus, error) =>
  {
    handleAjaxError(jqXHR, textStatus, error);
  });

  return ;
};

export const getNewsItemDetails = (news_id, onCompleteFunc) => {

  const url =  Globals.APIFolder + '/news/' + news_id ;

  getDataWithPromise(url, 'GET', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};

export const setNewsAsRead = (news_id, onCompleteFunc) => {

  const url =  Globals.APIFolder + '/news/' + news_id + '/read' ;

  getDataWithPromise(url, 'PUT', {}).then(data =>
  {
    onCompleteFunc ( data );
  })
      .catch((jqXHR, textStatus, error) =>
      {
        handleAjaxError(jqXHR, textStatus, error);
      });

  return ;
};
